import * as React from 'react';
import ModalDialog from './modal-dialog';
import style from './dialog.less';
import * as classNames from 'classnames';
import { WActionButton } from '../elements/WActionButton';

interface DialogWrapperProps extends React.ClassAttributes<any> {
    width?: number;
    height?: number;
    title?: string;
    closeButtonTitle?: string;
    styleClassExternal?: string;
    onAfterClose(): void;
    onResize?(size: any): void;
}

interface DialogWrapperState {
    isOpen: boolean;
}

export interface DialogWrapable {
    setDialogWrapper(dialogWrapper: DialogWrapper): any;
}

export default class DialogWrapper extends React.Component<DialogWrapperProps, DialogWrapperState> {
    constructor(props: DialogWrapperProps) {
        super(props);
        this.closeDialog = this.closeDialog.bind(this);
        this.state = {
            isOpen: true
        };
    }

    public closeDialog() {
        this.props.onAfterClose();
    }

    componentDidMount() {
    }

    render() {
        // const time = Date.now();
        return (
            <ModalDialog
                title={this.props.title}
                isOpen={this.state.isOpen}
                contentClassName={classNames(style.dialog, this.props.styleClassExternal)}
                width={this.props.width ? this.props.width : 'auto'}
                height={this.props.height ? this.props.height : 'auto'}
                onAfterClose={this.props.onAfterClose}
                onResize={this.props.onResize}
                buttons={[
                    {
                        title: this.props.closeButtonTitle,
                        onClick: this.closeDialog,
                    },
                ]}
            >
                <div className={style.ownTitleBar}>
                    {this.props.title && <div className={style.visibleTitle}>{this.props.title}</div>}
                    <WActionButton
                        label='Close'
                        action='cancel'
                        key='action_cancel'
                        onAction={this.closeDialog}
                    />
                </div>
                <div>
                    {this.props.children}
                </div>
            </ModalDialog>
        );
    }
}
